// Mock data for Aether Machining Inc.

export const services = [
  {
    id: 'cnc-milling',
    title: 'CNC Milling Services',
    shortDesc: 'High-precision CNC milling for complex components requiring tight tolerances and superior surface finishes.',
    image: 'https://customer-assets.emergentagent.com/job_aerospace-cnc/artifacts/l54ruz15_20200716_174435.jpg',
    capabilities: [
      '3-axis and multi-axis CNC milling',
      'Tight-tolerance machining',
      'Aluminum, steel, stainless steel, and exotic high heat resistant materials',
      'Prototype to production volumes'
    ],
    benefits: [
      'AS9100 Rev. D quality compliance',
      'Experienced machinists and controlled processes',
      'Reliable lead times and consistent results'
    ]
  },
  {
    id: 'cnc-turning',
    title: 'CNC Turning Services',
    shortDesc: 'Precision-machined cylindrical and rotational parts with consistent dimensions and excellent surface finishes.',
    image: 'https://customer-assets.emergentagent.com/job_aerospace-cnc/artifacts/dkxqshxu_20230519_180328%20%282%29.jpg',
    capabilities: [
      'Precision lathe machining',
      'Tight tolerance control',
      'Short-run and production machining',
      'Aerospace and industrial components'
    ],
    benefits: [
      'AS9100 Rev. D–compliant processes',
      'Repeatability and performance guaranteed',
      'Complex and simple geometries supported'
    ]
  },
  {
    id: 'aerospace-machining',
    title: 'Aerospace Machining',
    shortDesc: 'CNC machining of flight-critical and mission-critical component for aerospace applications.',
    image: 'https://images.unsplash.com/photo-1666618090858-fbcee636bd3e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxDTkMlMjBtYWNoaW5pbmd8ZW58MHx8fHwxNzY4MzU1MjQ2fDA&ixlib=rb-4.1.0&q=85',
    capabilities: [
      'Tight tolerances and complex geometries',
      'Full traceability and inspection',
      'Prototype through production support',
      'AS9100 Rev. D standards compliance'
    ],
    benefits: [
      'Aerospace industry expertise',
      'Defense and aviation support systems',
      'Mission-critical quality assurance'
    ]
  },
  {
    id: 'prototype-machining',
    title: 'Prototype & Short-Run',
    shortDesc: 'Fast, accurate prototype machining to support product development, testing, and validation.',
    image: 'https://customer-assets.emergentagent.com/job_aerospace-cnc/artifacts/lqbyz07s_20220402_164519.jpg',
    capabilities: [
      'Rapid prototyping services',
      'Engineering-friendly support',
      'Tight tolerances from day one',
      'Fast turnaround times'
    ],
    benefits: [
      'Quick iteration cycles',
      'Quality without compromise',
      'Seamless transition to production'
    ]
  },
  {
    id: 'production-machining',
    title: 'Production Machining',
    shortDesc: 'Consistent quality across repeat orders while maintaining efficiency and dependable delivery schedules.',
    image: 'https://customer-assets.emergentagent.com/job_aerospace-cnc/artifacts/a494bzzu_IMG_20200409_154439_520.jpg',
    capabilities: [
      'Scalable manufacturing',
      'Process control and repeatability',
      'AS9100 Rev. D quality oversight',
      'Volume production capabilities'
    ],
    benefits: [
      'Consistent part-to-part quality',
      'Reliable delivery schedules',
      'Cost-effective production runs'
    ]
  },
  {
    id: 'custom-parts',
    title: 'Custom Machined Parts',
    shortDesc: 'Custom machined parts built to specification based on drawings, CAD files, and technical requirements.',
    image: 'https://customer-assets.emergentagent.com/job_aerospace-cnc/artifacts/o2ue7m0g_CarbonFiberMolds.png',
    capabilities: [
      'Complex geometries',
      'Application-specific materials',
      'Engineering collaboration',
      'CAD file compatibility'
    ],
    benefits: [
      'Tailored solutions',
      'Technical expertise',
      'Precision manufacturing'
    ]
  }
];

export const certifications = [
  {
    name: 'AS9100 Rev. D',
    description: 'Aerospace quality management system certification'
  },
  {
    name: 'Quality-Focused Processes',
    description: 'Documented inspection and traceability systems'
  },
  {
    name: 'Continuous Improvement',
    description: 'Corrective action and quality assurance programs'
  }
];

export const companyInfo = {
  name: 'Aether Machining Inc.',
  address: '1146 N. Fountain Way, Suite #B',
  city: 'Anaheim, CA 92806',
  country: 'United States',
  phone: '877-317-3105',
  email: 'info@aethermachining.us'
};

export const testimonials = [
  {
    id: 1,
    name: 'Bao Nguyen',
    company: 'Cyber Aerospace Corp',
    role: 'General Manager',
    text: 'Aether Machining consistently delivers precision parts on time. Their AS9100 compliance gives us confidence in every order.',
    rating: 5
  },
  {
    id: 2,
    name: 'David Kramer',
    company: 'Trabuco Precision LLC',
    role: 'President',
    text: 'Outstanding quality and attention to detail. Their team understands the critical nature of aerospace components.',
    rating: 5
  },
  {
    id: 3,
    name: 'Tyler Anderson',
    company: 'Rock West Composites',
    role: 'Manufacturing Engineer II',
    text: 'From prototype to production, Aether Machining has been our trusted partner for precision CNC work.',
    rating: 5
  }
];